__turbopack_context__.v({
  "button": "turquoise-module-scss-module__aBhR4q__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "turquoise-module-scss-module__aBhR4q__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "turquoise-module-scss-module__aBhR4q__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "turquoise-module-scss-module__aBhR4q__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "turquoise-module-scss-module__aBhR4q__small" + " " + __turbopack_context__.i(693367)["small"],
});
